import React from "react";
import { useState } from "react";
// components
import { ethers,utils } from "ethers";
import {getProvider} from "./Provider";
import CardStats from "components/Cards/CardStats.js";

export default function Tables() {
  const [myearnings,setmyearnings]=useState();
  const [mybalance,setmybalance]=useState();
  const [mybalanceX,setmybalanceX]=useState();
  const address = "0x387d19322826A02d60a3ce6934DA144378EBfF85";
const abi = [
  "function earned(address account) view returns (uint256)"
];
//await earned().then().catch()
 
  function convert(bigNumber, unit="ether"){
    if(typeof bigNumber !== "object") return bigNumber;
    return utils.formatUnits(bigNumber.toString(),unit);

  }

 

  // if(window.ethereum){
    
  balanceOf()
  //  earned();



   async function balanceOf() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    const account = await provider.listAccounts();
    const MTaddress = "0x6364c250a26f171e05b9D26b66baB17921eC72b9";
const MTabi = [
  "function balanceOf(address account) view returns (uint256)"
];
    const contract = new ethers.Contract(MTaddress, MTabi, signer);   
    const result = await contract.functions.balanceOf(account[0]);
  
   // console.log("result", result);
    setmybalance(convert(result[0]))
  } 


// }else{
//   alert("Use A Dapp Browser")
// }
balanceOfX()
async function balanceOfX() {
  const provider = await getProvider()
  const signer = provider.getSigner()
  const XMTaddress = "0xE99c1deB0234CE433DA7233D0a8934Fb379e600b";
const XMTabi = [
"function balanceOf(address account) view returns (uint256)"
];
const account = await provider.listAccounts();
  const contract = new ethers.Contract(XMTaddress, XMTabi, signer);   
  const result = await contract.functions.balanceOf(account[0]);

 // console.log("result", result);
  setmybalanceX(convert(result[0]))
} 

  
 
 ;
  const [tokeAmount,setTokenAmount]=useState();
  const [days,setDays]=useState('');
  let[MYAPY,setMYAPY]=useState(0);

  function CaculateApy(){
    let apyIndays=165343999999990*60*60*days;
    let APY_outCome=apyIndays+tokeAmount*1000000000000000000;
    // MYAPY=APY_outCome/1000000000000000000;
     setMYAPY(APY_outCome/1000000000000000000)

    /***
     * get Token amount to INvest
     * get days
     * calculate Apy 
     * 
     */
  }
  return (
    <>
      <div style={{
        marginTop:"100px"
      }} className="relative bg-light my-Font Blue-white md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div className="flex flex-col">
            {/* Card stats */}
            <div className="flex flex-row">
              <div className="w-full lg:w-full py-6 xl:full px-4">
                <CardStats
                  statSubtitle="Your Balance"
                  statTitle={mybalance}
                  statArrow=""
                  statPercent=''
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
             
            </div>
            <div className="flex flex-row">
              <div className="w-full lg:w-full py-6 xl:full px-4">
                <CardStats
                  statSubtitle="XMFA BALANCE"
                  statTitle={mybalanceX}
                  statArrow=""
                  statPercent='Daily ROI 2.35'
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
             
            </div>
         
            <div className="flex flex-row">
              <div className="w-full lg:w-1/3 py-6 xl:w-1/3 px-4">
                <label>
                  Token Amount
                </label>
              <div class="mb-3 pt-0">
  <input type="text" placeholder="Large Input" onChange={(e)=>setTokenAmount(e.target.value)}  class="px-3 py-4 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"/>
</div>
              </div>
             
              <div className="w-full lg:w-1/3 xl:w-1/3 py-6 px-4">
              <label>
                    APY  (%)
                </label>
              <div class="mb-3 pt-0 font-extrabold text-lg">{MYAPY.toString()}
</div>
              </div>
              
            </div>
            
            <div className="flex flex-row items-center  ">
              <div className="w-full lg:w-1/3 py-6 xl:w-1/3 px-4">
              <label>
                Days
                </label>
              <div class="mb-3 pt-0">
  <input type="text" placeholder="Days"  onChange={(e)=>setDays(e.target.value)} class="px-3 py-4 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"/>
</div>
              </div>
              <div>
                <button onClick={CaculateApy} className="rounded-full py-4  ml-20 px-12 bg-white text-2xl">
                  Calculate
                </button>
              </div>
             
              
              
            </div>
           
            
          </div>
        </div>
      </div>
    </>
  );
}
